module.exports = __webpack_public_path__ + "static/media/chameleon-favicon.8aabae77.ico";